module.exports = __webpack_public_path__ + "static/media/warning.a15cb8b9.svg";